import Nav from "./Nav";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0B0F0E] text-[#F4EFE6]">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
